<template>
  <div class="big platformCoupon">
    <div class="page_title">券包</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <el-tabs v-model="activeName">
          <el-tab-pane label="券包" name="1"></el-tab-pane>
        </el-tabs>
        <component :is="currentComponent" />
      </div>
    </div>
  </div>
</template>
  
  <script>
import CouponList from "./CouponList/index.vue";
export default {
  components: {
    CouponList,
  },
  data() {
    return {
      activeName: "1",
    };
  },
  filters: {
    // dateFormat(val) {
    //   return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:ss");
    // },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.activeName) {
        case "1":
          return CouponList;
      }
    },
  },
  created() {},
  methods: {},
};
</script>
  
  <style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
</style>